import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import SEOHead from '../../components/SEO/SEOHead';

export default function ServicesPage() {
  const { t } = useTranslation();

  const seoData = {
    title: 'خدمات گلخانه سبز آریا - طراحی، ساخت و نگهداری گلخانه‌های هوشمند | مشاوره تخصصی',
    description: 'خدمات کامل گلخانه‌سازی شامل طراحی و ساخت گلخانه‌های هوشمند، نصب سیستم‌های اتوماسیون، مشاوره تخصصی، نگهداری و تعمیرات، آموزش کشاورزان و پشتیبانی 24 ساعته.',
    keywords: 'خدمات گلخانه‌سازی، طراحی گلخانه، ساخت گلخانه هوشمند، نصب اتوماسیون گلخانه، مشاوره گلخانه، نگهداری گلخانه، تعمیرات گلخانه، آموزش کشاورزی، پشتیبانی گلخانه، خدمات پس از فروش، مهندسی گلخانه',
    ogImage: 'https://public.readdy.ai/ai/img_res/64c6e578f8f2db310760df15b4b902be.jpg',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "خدمات گلخانه‌سازی آریا",
      "description": "خدمات کامل طراحی، ساخت و نگهداری گلخانه‌های هوشمند",
      "provider": {
        "@type": "Organization",
        "name": "گلخانه سبز آریا",
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "IR",
          "addressLocality": "Tehran"
        }
      },
      "serviceType": "Agricultural Technology Services",
      "areaServed": {
        "@type": "Country",
        "name": "Iran"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "خدمات گلخانه‌سازی",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "طراحی و ساخت گلخانه",
              "description": "طراحی و ساخت گلخانه‌های مدرن با فناوری هلندی"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "نصب سیستم‌های هوشمند",
              "description": "نصب و راه‌اندازی سیستم‌های اتوماسیون"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "مشاوره تخصصی",
              "description": "مشاوره در زمینه کشت و تولید"
            }
          }
        ]
      }
    }
  };

  const services = [
    {
      title: 'طراحی و مشاوره',
      description: 'طراحی حرفه‌ای گلخانه بر اساس نیاز شما',
      icon: 'ri-pencil-ruler-2-line',
      features: [
        'طراحی سازه‌ای مقاوم',
        'محاسبه ظرفیت تولید',
        'انتخاب مواد مناسب',
        'برنامه‌ریزی فضای کاشت'
      ]
    },
    {
      title: 'ساخت و نصب',
      description: 'ساخت و نصب گلخانه با بالاترین کیفیت',
      icon: 'ri-hammer-line',
      features: [
        'ساخت سازه فلزی',
        'نصب پوشش پلاستیک',
        'سیستم تهویه',
        'درب و پنجره اتوماتیک'
      ]
    },
    {
      title: 'سیستم آبیاری',
      description: 'طراحی و نصب سیستم آبیاری هوشمند',
      icon: 'ri-drop-line',
      features: [
        'آبیاری قطره‌ای',
        'سیستم فرتیگیشن',
        'کنترل اتوماتیک',
        'مانیتورینگ مصرف آب'
      ]
    },
    {
      title: 'کنترل اقلیم',
      description: 'سیستم‌های کنترل دما و رطوبت',
      icon: 'ri-temp-cold-line',
      features: [
        'سیستم گرمایش',
        'سیستم سرمایش',
        'کنترل رطوبت',
        'سنسورهای هوشمند'
      ]
    },
    {
      title: 'اتوماسیون',
      description: 'سیستم‌های هوشمند کنترل گلخانه',
      icon: 'ri-robot-line',
      features: [
        'کنترل از راه دور',
        'برنامه‌ریزی خودکار',
        'هشدارهای هوشمند',
        'گزارش‌گیری دقیق'
      ]
    },
    {
      title: 'پشتیبانی',
      description: 'خدمات پس از فروش و نگهداری',
      icon: 'ri-customer-service-2-line',
      features: [
        'نگهداری دوره‌ای',
        'تعمیرات اضطراری',
        'آموزش کاربران',
        'بروزرسانی سیستم'
      ]
    }
  ];

  const process = [
    {
      step: '۱',
      title: 'مشاوره اولیه',
      description: 'بررسی نیازها و امکان‌سنجی پروژه'
    },
    {
      step: '۲',
      title: 'طراحی',
      description: 'ارائه طرح کامل و محاسبات فنی'
    },
    {
      step: '۳',
      title: 'تولید',
      description: 'ساخت قطعات و تجهیزات مورد نیاز'
    },
    {
      step: '۴',
      title: 'نصب',
      description: 'نصب و راه‌اندازی گلخانه'
    },
    {
      step: '۵',
      title: 'تست',
      description: 'آزمایش و تنظیم سیستم‌ها'
    },
    {
      step: '۶',
      title: 'تحویل',
      description: 'آموزش و تحویل نهایی پروژه'
    }
  ];

  return (
    <div className="min-h-screen">
      <SEOHead {...seoData} />
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center bg-cover bg-center pt-24 mt-20"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Professional%20greenhouse%20construction%20services%20modern%20agricultural%20facility%20design%20smart%20farming%20technology%20installation%20consultation&width=1920&height=600&seq=services-hero&orientation=landscape&format=webp&quality=80')`
        }}
      >
        <div className="container mx-auto px-4 lg:px-8 text-center text-white">
          <h1 className="text-5xl lg:text-6xl font-bold mb-6">
            خدمات ما
          </h1>
          <p className="text-xl lg:text-2xl max-w-3xl mx-auto">
            طراحی، ساخت و تجهیز گلخانه‌های هوشمند
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">
              خدمات کامل گلخانه
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              از طراحی تا تحویل، تمام مراحل ساخت گلخانه را پوشش می‌دهیم
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-2xl text-green-600`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6">
                  {service.description}
                </p>
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-gray-700">
                      <i className="ri-check-line text-green-600 ml-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">
              فرآیند کار
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              مراحل انجام پروژه از ابتدا تا انتها
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {process.map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-green-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                  {item.step}
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">
                  {item.title}
                </h3>
                <p className="text-gray-600">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-green-600">
        <div className="container mx-auto px-4 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            آماده شروع پروژه هستید؟
          </h2>
          <p className="text-xl text-green-100 mb-8 max-w-2xl mx-auto">
            با تیم متخصص ما تماس بگیرید و مشاوره رایگان دریافت کنید
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/contact" className="bg-white text-green-600 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap">
              درخواست مشاوره
            </a>
            <a href="tel:02188441386" className="border-2 border-white text-white px-8 py-4 rounded-lg font-bold hover:bg-white hover:text-green-600 transition-colors whitespace-nowrap">
              تماس فوری
            </a>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
